import { useToastStore } from "@/stores/toastStore";

/**
 * Backwards-compatible facade over the Pinia toast store.
 * Kept because 30+ modules import this service; new code should
 * use `useToastStore()` directly.
 */
class NotificationService {
    private get toast() {
        return useToastStore();
    }

    success(message: string) {
        this.toast.success(message);
    }

    error(message: string) {
        this.toast.error(message);
    }

    info(message: string) {
        this.toast.info(message);
    }

    warning(message: string) {
        this.toast.warning(message);
    }
}

const notificationService = new NotificationService();

export default notificationService;
